import { render, staticRenderFns } from "./PriceInfoModal.vue?vue&type=template&id=ab6a0080&"
import script from "./PriceInfoModal.vue?vue&type=script&lang=js&"
export * from "./PriceInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports